export const curDateTime = function () {
	return `${CurDate()} ${CurTime()}`;
}

export const CurDate = function () {
	const date = new Date();
	return formDateFormat(handleFullYear(date), handleMonth(date), handleDay(date));
};

export const CurTime = function () {
	const date = new Date();
	return timeFormat(handleHour(date), handleMinute(date), handleSecond(date));

}

export const CurDateStartTime = function () {
	const date = new Date();
	date.setHours(0, 0, 0, 0); // Set to midnight

	return `${CurDate()} ${timeFormat(handleHour(date), handleMinute(date), handleSecond(date))}`;
};

export const CurDateEndTime = function () {
	const date = new Date();
	date.setHours(23, 59, 59, 59); // Set to midnight
	return `${CurDate()} ${timeFormat(handleHour(date), handleMinute(date), handleSecond(date))}`;
};

export const formDate = function (timestamp) {
	if (!timestamp || isNaN(new Date(timestamp))) return "";
	const date = new Date(timestamp);
	return formDateFormat(handleFullYear(date), handleMonth(date), handleDay(date));
};

export const formDateTime = function (timestamp) {
	if (!timestamp || isNaN(new Date(timestamp))) return "";
	const date = new Date(timestamp);
	return `${formDateFormat(handleFullYear(date), handleMonth(date), handleDay(date))} ${timeFormat(handleHour(date), handleMinute(date), handleSecond(date))}`;
};

export const UnixTimeToDateTime = function (timestamp) {
	if (typeof timestamp == "undefined" || timestamp == null || timestamp == "NaN" || timestamp.toString().trim() == "" || isNaN(new Date(timestamp))) {
		return "";
	}

	const date = new Date(timestamp);
	return `${standardDateFormat(handleFullYear(date), handleMonth(date), handleDay(date))} ${timeFormat(handleHour(date, true), handleMinute(date), handleSecond(date), handleAmPm(date))}`;
};

export const UnixTimeToDate = function (timestamp) {

	if (typeof timestamp == "undefined" || timestamp == null || timestamp == "NaN" || timestamp.toString().trim() == "" || isNaN(new Date(timestamp))) {
		return "";
	}

	const date = new Date(timestamp);
	return standardDateFormat(handleFullYear(date), handleMonth(date), handleDay(date));

};

export const UnixTimeToYM = function (timestamp) {
	if (typeof timestamp == "undefined" || timestamp == null || timestamp == "NaN" || timestamp.toString().trim() == "" || isNaN(timestamp)) {
		return "";
	}
	const year = handleFullYear(timestamp, 2);
	const month = handleMonth(timestamp);
	return `${year}${month}`
}

export const getHourDesc = hour => {
	return hour < 10 ? `0${hour}:00` : `${hour}:00`;
};

export const handleFullYear = function (date, digit = 4) {
	return digit == 4 ? date.getFullYear() : date.getFullYear().toString().slice(-2)
}

const handleMonth = function (date) {
	return String(date.getMonth() + 1).padStart(2, '0')
}

const handleDay = function (date) {
	return String(date.getDate()).padStart(2, '0')
}

const handleHour = function (date, twelve_hour = false) {
	const hour = date.getHours();
	const final_hour = twelve_hour ? (hour % 12 || 12) : hour
	return String(final_hour).padStart(2, '0')
}

const handleMinute = function (date) {
	return String(date.getMinutes()).padStart(2, '0')
}

const handleSecond = function (date) {
	return String(date.getSeconds()).padStart(2, '0')
}

const handleAmPm = function (date) {
	return date.getHours() >= 12 ? 'pm' : 'am';
}

const timeFormat = function (hour, minute, second, ampm = null) {
	return `${hour}:${minute}:${second}${ampm != null ? ` ${ampm}` : ''}`;
}

const formDateFormat = function (year, month, day) {
	return `${year}-${month}-${day}`
}

const standardDateFormat = function (year, month, day) {
	return `${day}/${month}/${year}`;
}

/**
 * Date Calculation
 */
export const dateMonthCalc = function (date, no_month_day, add = 0) {
	date.setMonth(add == 1 ? (date.getMonth() + no_month_day) : (date.getMonth() - no_month_day));
	return date.toISOString().substring(0, 10)
}

export const dateDayCalc = function (date, no_day, add = 0) {
	date.setDate(add == 1 ? (date.getDate() + no_day) : (date.getDate() - no_day));
	return date.toISOString().substring(0, 10)
}